import {useState} from "react";

const usePieGrid = ()=>{
    const [pieData, setPieData] = useState(null);
    const [showPies, setShowPies] = useState(false);

    const togglePies = (state)=>{
        setShowPies(state ?? !showPies);
    }

    const updatePieData = (data)=>{
        if (JSON.stringify(data) !== JSON.stringify(pieData)){
            setPieData(data);
            setShowPies(true);
        }

    }

    return {
        pieData,
        showPies,
        setPieData,
        togglePies,
        updatePieData

    }
}

export default usePieGrid;